import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import mainStyles from '../../styles.module.scss';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { CCMClientSettingsConfig } from '../../config/CCMClientSettingsConfig';
import { VerticalTabComponent } from '../vertical-tab/VerticalTabComponent';
import { OverviewRowComponent } from '../overview-row/OverviewRowComponent';
import { useDeepCompareEffect } from '../../utils';
import _ from 'lodash';

export const ProgramsOverviewComponent = ({ programOverviews = [] }) => {
  const { PROGRAM_OVERVIEW_LABEL_MAP, DEFAULT_LABEL, getSortedOverview } = CCMClientSettingsConfig;

  const programs = useMemo(() =>
    programOverviews.sort((a, b) => a.program_name.localeCompare(b.program_name), [programOverviews])
  );
  const [selectedProgram, setSelectedProgram] = useState();
  const sortedProgramFields = useMemo(
    () => getSortedOverview(selectedProgram, PROGRAM_OVERVIEW_LABEL_MAP),
    [selectedProgram, programs]
  );

  useEffect(() => {
    if (programs.length && !selectedProgram) setSelectedProgram(programs[0]);
  }, [programs.length]);

  useDeepCompareEffect(() => {
    if (selectedProgram) {
      const updatedProgram = _.find(programs, ({ id: programId }) => programId === selectedProgram.id);
      setSelectedProgram(updatedProgram);
    }
  }, [programs]);

  const onProgramClick = program => {
    const newSelectedProgram = _.find(programs, ({ id: programId }) => programId === program.id);

    if (!_.isNil(newSelectedProgram)) {
      setSelectedProgram(newSelectedProgram);
    }
  };

  if (programs.length === 0) return null;

  return (
    <div className={classNames(mainStyles.overviewContainer)}>
      <h3>Programs Overview</h3>
      <div className={classNames('flex flex-row', styles.programOverviewContainer)}>
        <div className={classNames(styles.programsList)}>
          <VerticalTabComponent
            data={programs.map(({ id: programId, program_name: programName, status: programStatus }) => ({
              id: programId,
              name: programName,
              is_active: ['Active', 'Draft'].includes(programStatus)
            }))}
            label="Programs"
            currentItem={selectedProgram ? selectedProgram.id : ''}
            handleClick={onProgramClick}
          />
        </div>
        <div className={classNames(styles.programsOverview)}>
          <table>
            <tbody>
              {_.isNil(selectedProgram) || _.isEmpty(selectedProgram) ? (
                <tr>
                  <td>No Data</td>
                </tr>
              ) : (
                sortedProgramFields.map(key => {
                  if (!Object.keys(PROGRAM_OVERVIEW_LABEL_MAP).includes(key)) return null;
                  return (
                    <OverviewRowComponent
                      key={key}
                      propKey={key.toLowerCase()}
                      value={selectedProgram[key]}
                      label={PROGRAM_OVERVIEW_LABEL_MAP[key].label || DEFAULT_LABEL}
                      type="program"
                      overviewPropertyType={PROGRAM_OVERVIEW_LABEL_MAP[key].type}
                    />
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

ProgramsOverviewComponent.propTypes = {
  programOverviews: PropTypes.array
};
